module.exports = __webpack_public_path__ + "static/media/ambassador-bro.da11264b.svg";